
    var riot = require('riot')
    //src: starling/src/tags/node-attribute-editor.html
riot.tag2('node-attribute-editor',
  '<form class="attribute-editor_form" onsubmit="{handleSubmit}"> <h4 class="attribute-editor_title">{isEditing ? \'Edit tag\' : \'Add tag…\'}</h4> <div class="attribute-editor_pill-container"> <input class="attribute-editor_input attribute-editor_input--name" type="text" ref="name" placeholder="ex. Priority" onkeyup="{handleNameKeyUp}" onkeydown="{handleKeyDown}" riot-value="{attributeName}"> <input class="attribute-editor_input attribute-editor_input--value" type="text" ref="value" placeholder="ex. high" onkeyup="{handleValueKeyUp}" onkeydown="{handleKeyDown}" riot-value="{attributeValue}"> </div> <div class="attribute-editor_keys-list scrollable" if="{this.view == \'key-suggestions\'}"> <ul> <li each="{name in this.getAutocompleteKeys()}" onclick="{handleAutocompleteKeyClick.bind(this, name)}" class="attribute-editor_keys-list_key attribute-editor_list-item"> <div class="attribute-editor_pill attribute-editor_pill--full"> {name} <div class="attribute-editor_examples"> ex. <span class="attribute-editor_examples_value" each="{suggestion in getAutocompleteValues(name)}">{suggestion.value}</span> </div> </div> </li> </ul> </div> <div class="attribute-editor_values-list scrollable" if="{this.view == \'value-suggestions\'}"> <ul> <li class="attribute-editor_list-item" each="{suggestion in getAutocompleteValues()}" onclick="{handleAutocompleteValueClick.bind(this, suggestion.name, suggestion.value)}"> <div class="attribute-editor_pill {suggestion.applied ? \'attribute-editor_pill--active\' : \'\'}"> <span class="key">{suggestion.name}</span> <span class="value">{suggestion.value}</span> </div> </li> </ul> </div> <button class="attribute-editor_save-button Button Button--Small Button--Secondary" disabled="{!valueFilter}" type="submit"> {isEditing ? \'Save\' : \'Add\'} </button> </form>',
  '',
  'show="{isVisible}" ref="main" class="attribute-editor" riot-style="{this.getStyle()}" onmouseenter="{this.handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var _attributesUi = require('lib/node/attributes-ui');

var _bulkAttributesUi = require('lib/bulk-attributes-ui');

var _constants = require('lib/constants');

var _nodesUi = require('lib/nodes-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAB = _constants.KEY_CODES.TAB,
    ENTER = _constants.KEY_CODES.ENTER,
    SHIFT = _constants.KEY_CODES.SHIFT;

this.isVisible = false;
this.canvas = this.opts.canvas;
this.operation = this.canvas.operation;
this.canvas.nodeAttributeEditor = this;
this.isOpen = false;
this.origin = null;

this.initialize = function () {
  _this.view = 'key-suggestions';
  _this.attributeName = null;
  _this.attributeValue = null;
  _this.nameFilter = null;
  _this.valueFilter = null;
  if (_this.refs.name) {
    _this.refs.name.value = '';
    _this.refs.name.focus();
    _this.refs.value.value = '';
  }
};

this.reset = function () {
  delete _this.attributeId;
  delete _this.node;
  _this.clearInputs();
};

this.clearInputs = function () {
  delete _this.attributeId;
  _this.prevName = null;
  _this.prevValue = null;
  _this.initialize();
};

this.showNew = function (name) {
  _this.initialize();
  _this.attributeName = name;
  _this.view = 'new';
  _this.update();
  if (name) {
    _this.refs.value.focus();
  } else {
    _this.refs.name.focus();
  }
};

this.getAutocompleteKeys = function () {
  var filter = (_this.nameFilter || '').trim();
  var keys = store.getAttributeFilterObj();

  return Object.keys(keys).sort(function (a, b) {
    return keys[b].count - keys[a].count;
  }).filter(function (n) {
    return n.includes(filter);
  });
};

this.autocompleteKeys = this.getAutocompleteKeys();

this.getAutocompleteValues = function (nameFilter) {
  var valueFilter = (_this.valueFilter || '').trim();
  var attributes = store.getAttributeFilterObj();
  var values = [];

  nameFilter = nameFilter || (_this.nameFilter || '').trim();

  var _loop = function _loop() {
    var attribute = attributes[name];

    if (!attribute) return 'continue';
    if (nameFilter && name !== nameFilter) return 'continue';

    var attributeValues = attribute.values;
    var nameValues = Object.keys(attributeValues).sort(function (a, b) {
      return attributeValues[b].count - attributeValues[a].count;
    }).filter(function (value) {
      return _this.isEditing || value.includes(valueFilter);
    });

    values.push.apply(values, nameValues.map(function (value) {
      return { name: name, value: value };
    }));
  };

  for (name in attributes) {
    var _ret = _loop();

    if (_ret === 'continue') continue;
  }

  if (_this.node && _this.node.getAttributes()) {
    var _loop2 = function _loop2() {
      if (_isArray) {
        if (_i >= _iterator.length) return 'break';
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) return 'break';
        _ref = _i.value;
      }

      var value = _ref;

      var hasAttributeApplied = Boolean(_this.node.getAttributes().find(function (attr) {
        return attr.name === value.name && attr.value === value.value;
      }));

      if (hasAttributeApplied) {
        value.applied = true;
      }
    };

    for (var _iterator = values, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      var _ret2 = _loop2();

      if (_ret2 === 'break') break;
    }
  }

  return values.sort(function (a, b) {
    if (!valueFilter) return 0;
    if (a.value.includes(valueFilter)) return -1;
    if (b.value.includes(valueFilter)) return 1;
    return 0;
  });
};

this.autocompleteValues = [];

this.handleKeyDown = function (e) {
  e.stopPropagation();
  if (e.keyCode === TAB && !e.shiftKey) {
    // allow shift + tab to focus on key input when in value input

    e.preventDefault();
  }
};

this.handleNameKeyUp = function (e) {
  if (e.keyCode === ENTER) {
    // let the submit handler take care of saves
    return;
  }
  if (e.shiftKey && e.keyCode === TAB) {
    // allow shift + tab to focus on key input when in value input
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  var name = e.target.value;
  _this.nameFilter = name;
  _this.attributeName = name;
  if (e.keyCode === TAB) {
    _eventTracking2.default.track({
      category: 'Attributes',
      action: 'Attr-Editor-Key-Entered',
      label: 'Attribute-Key-Chosen'
    });
    return _this.chooseKey(name);
  }

  _this.view = 'key-suggestions';
  _this.update();
};

this.nameRefIsEmpty = function () {
  var nameString = _this.refs.name.value.trim();
  return !nameString || nameString === '#';
};

this.handleValueKeyUp = function (e) {
  e.preventDefault();
  e.stopPropagation();

  _this.valueFilter = e.target.value;
  _this.attributeValue = e.target.value;
  _this.view = 'value-suggestions';
  _this.update();
};

this.handleKeyFocus = function () {
  _this.view = 'key-suggestions';
  _this.update();
};

this.handleValueFocus = function () {
  _this.view = 'value-suggestions';
  _this.update();
};

this.handleSubmit = function (e) {
  e.preventDefault();
  e.stopPropagation();

  var _refs = _this.refs,
      name = _refs.name,
      value = _refs.value;

  if (_this.nameRefIsEmpty()) {
    name.value = '#';
    _this.attributeName = '#';
  }

  if (!value.value.trim()) {
    value.focus();
    return;
  }

  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Editor-Value-Entered',
    label: 'Attribute-Value-Chosen'
  });

  return _this.saveAttribute();
};

this.handleAutocompleteKeyClick = function (name) {
  _this.chooseKey(name);
  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Editor-Autocomplete-Key-Click',
    label: 'Attribute-Key-Chosen'
  });
};

this.chooseKey = function (name) {
  if (!name.trim()) name = '#';
  name = name.trim();
  _this.refs.name.value = name;
  _this.attributeName = name;
  _this.nameFilter = name;
  _this.refs.value.focus();
  _this.view = 'value-suggestions';
  _this.update();
};

this.handleAutocompleteValueClick = function (name, value) {
  _this.chooseValue(name, value);
  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Editor-Autocomplete-Value-Click',
    label: 'Attribute-Value-Chosen'
  });
};

this.chooseValue = function (name, value) {
  _this.attributeName = name;
  _this.attributeValue = value;
  _this.saveAttribute();
  _this.update();
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.summon = function (_ref2) {
  var referenceEl = _ref2.referenceEl,
      node = _ref2.node,
      attributeId = _ref2.attributeId,
      isBulkAction = _ref2.isBulkAction,
      origin = _ref2.origin,
      positionToLeft = _ref2.positionToLeft,
      isEditing = _ref2.isEditing,
      reset = _ref2.reset;

  if (_this.canvas.isViewOnly()) {
    return;
  }

  if (!node && !isBulkAction) {
    return;
  }

  var _refs2 = _this.refs,
      value = _refs2.value,
      name = _refs2.name;

  if (reset || !_this.fromOrigin(origin) || _this.node && node && _this.node.id != node.id) {
    // reset our inputs if we pull this up off a different node or menu. otherwise keep existing state in place
    _this.reset();
  }

  _this.isOpen = true;
  _this.origin = origin;
  _this.isBulkAction = isBulkAction;
  _this.isEditing = isEditing;

  _this.summoned = true;
  _this.node = node;
  _this.attributeId = attributeId;
  if (_this.attributeId && _this.node) {
    // populate inputs with current values if editing...
    var attr = _this.node.getAttribute({ id: _this.attributeId });
    value.value = attr.value;
    name.value = attr.name;
    _this.prevName = attr.name;
    _this.prevValue = attr.value;
    _this.valueFilter = attr.value;
    _this.attributeValue = attr.value;
    _this.nameFilter = attr.name;
    _this.view = 'value-suggestions';
    var nodeTag = _this.canvas.nodeTags[_this.node.id];
    var pill = nodeTag.refs.container.querySelector('span[data-id=\'' + _this.attributeId + '\']');
    pill.classList.add('node-attribute--active');
  }

  _this.attributeName = _this.getAttributeName() || _this.attributeName;
  _this.attributeValue = _this.getAttributeValue() || _this.attributeValue;

  if (_this.isBulkAction) {
    _this.naui = null;
  } else {
    _this.naui = new _attributesUi.NodeAttributesUI({ canvas: _this.canvas, nodeId: _this.node.id });
  }

  _this.isVisible = true;

  _this.update();
  _this.positionToLeft = positionToLeft;
  _this.parentRect = referenceEl.getBoundingClientRect();
  _this.discoverSize();
  _this.repositionPanel();
  _this.update();

  if (name.value) {
    value.focus();
  } else {
    name.focus();
  }
};

/*
  note: copied from node-perspective-panel
  these 2 panels share similar positioning logic that other menus don't
  because these panels may change size as they're being used.
*/
this.discoverSize = function () {
  var menuRect = _this.refs.main.getBoundingClientRect();
  _this.width = menuRect.width;
  _this.height = menuRect.height;
};
this.repositionPanel = function () {
  _this.top = '';
  _this.left = '';
  _this.right = '';
  _this.bottom = '';

  if (_this.fromOrigin('toolbar')) {
    _this.top = _this.y = _this.parentRect.top + _this.parentRect.height + 1;
    _this.left = _this.parentRect.left - _this.width / 2 + _this.parentRect.width / 2;
    _this.refs.main.style.top = _this.top;
    _this.refs.main.style.left = _this.left;
    _this.refs.main.style.right = _this.right;
    _this.refs.main.style.bottom = _this.bottom;
    return;
  }

  if (_this.positionToLeft) {
    _this.y = _this.parentRect.top;
    _this.top = _this.y;
    _this.right = window.innerWidth - _this.parentRect.left;
  } else {
    _this.x = _this.parentRect.right;
    _this.y = _this.parentRect.top;
    _this.top = _this.y;
    _this.left = _this.x;
  }
  if (_this.height + _this.top > window.innerHeight) {
    _this.top = window.innerHeight - _this.height;
  }
  _this.refs.main.style.top = _this.top;
  _this.refs.main.style.left = _this.left;
  _this.refs.main.style.right = _this.right;
  _this.refs.main.style.bottom = _this.bottom;
};
this.getStyle = function () {
  var strX = '';
  var strY = '';
  if (_this.right) {
    strX = 'right: ' + _this.right + 'px;';
  } else if (_this.left) {
    strX = 'left: ' + _this.left + 'px;';
  }

  if (_this.bottom) {
    strY = 'bottom: ' + _this.bottom + 'px;';
  } else if (_this.top) {
    strY = 'top: ' + _this.top + 'px;';
  }
  return strX + ' ' + strY;
};

this.hide = function () {
  delete _this.summoned;
  delete _this.naui;
  _this.isOpen = false;
  _this.isVisible = false;
  _this.isBulkAction = false;
  _this.isEditing = null;
  if (_this.node) {
    var nodeTag = _this.canvas.nodeTags[_this.node.id];
    if (nodeTag && nodeTag.refs.container) {
      var pills = nodeTag.refs.container.querySelectorAll('.node-attribute');
      for (var _iterator2 = pills, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref3 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref3 = _i2.value;
        }

        var pill = _ref3;

        pill.classList.remove('node-attribute--active');
      }
    }
    delete _this.node;
  }
  //this.reset();
  _this.update();
};

this.getAttributeName = function () {
  if (_this.attributeId && _this.node) {
    var attr = _this.node.attributes.card.find(function (a) {
      return a.id === _this.attributeId;
    });
    return attr && attr.name || '';
  }
  return '';
};

this.getAttributeValue = function () {
  if (_this.attributeId && _this.node) {
    var attr = _this.node.attributes.card.find(function (a) {
      return a.id === _this.attributeId;
    });
    return attr && attr.value || '';
  }
  return '';
};

this.saveAttribute = function () {
  var operationMessages = [];

  if (_this.isBulkAction) {
    _this.saveBulkAttribute();
  } else {
    var node = _this.node;

    _this.saveSingleAttribute({ operationMessages: operationMessages });
    var nodeTag = _this.canvas.nodeTags[node.id];

    var _nui$fixOverlaps = _nodesUi.nui.fixOverlaps({
      nodeTag: nodeTag,
      fromExpand: !node.getIsCollapsed(),
      fromCollapse: node.getIsCollapsed(),
      allowedDirections: ['right', 'down']
    }),
        prevNodePositions = _nui$fixOverlaps.prevNodePositions,
        nodePositions = _nui$fixOverlaps.nodePositions;

    nodeTag.rediscoverLinkPositions();

    if (nodePositions.length) {
      var message = _this.canvas.operation.messages.updateNodePositions({
        prevNodePositions: prevNodePositions,
        nodePositions: nodePositions,
        prevLinkAngles: [],
        linkAngles: []
      });
      operationMessages.push(message);
    }
  }

  if (operationMessages.length) {
    _this.canvas.operation.batchOperation({
      messages: operationMessages,
      onFailure: function onFailure(err) {
        console.log('saveSingleAttribute batchOperation operation failed: ' + err);
      }
    });
  }
};

this.saveBulkAttribute = function () {
  var _refs3 = _this.refs,
      nameRef = _refs3.name,
      valueRef = _refs3.value;

  var nodeIds = _this.canvas.getSelectedNodes().map(function (n) {
    return n.id;
  });
  var name = _this.attributeName;
  var value = _this.attributeValue;

  if (_this.attributeId) {
    // TODO: see if we need to handle bulk edit...

  } else {
    _bulkAttributesUi.baui.addAttribute({
      nodeIds: nodeIds,
      name: name,
      value: value
    });
  }

  var scope = 'Both';
  if (name && !value) {
    scope = 'Key';
  } else if (!name && value) {
    scope = 'Value';
  }

  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Editor-Bulk-Add-' + scope,
    label: 'Attribute-Added'
  });

  nameRef.value = '';
  valueRef.value = '';

  nameRef.focus();
};

this.saveSingleAttribute = function (_ref4) {
  var operationMessages = _ref4.operationMessages;
  var _refs4 = _this.refs,
      nameRef = _refs4.name,
      valueRef = _refs4.value;

  var name = _this.attributeName;
  var value = _this.attributeValue;

  if (_this.attributeId) {
    _this.naui.editAttribute({
      id: _this.attributeId,
      nodeId: _this.node.id,
      name: name,
      value: value,
      prevName: _this.prevName,
      prevValue: _this.prevValue,
      operationMessages: operationMessages
    });
    var scope = 'Both';

    var equiv = function equiv(v1, v2) {
      if (!v1 && !v2) return true;
      if (v1 == v2) return true;
      return false;
    };

    if (equiv(value, _this.prevValue) && equiv(name, _this.prevName)) {
      scope = 'None';
    } else if (value && equiv(name, _this.prevName) && !equiv(value, _this.prevValue)) {
      scope = 'Value';
    } else if (name && !equiv(name, _this.prevName) && equiv(value, _this.prevValue)) {
      scope = 'Key';
    }

    _eventTracking2.default.track({
      category: 'Attributes',
      action: 'Attr-Editor-Single-Edit-' + scope,
      label: 'Attribute-Edited'
    });
  } else if (!_this.node.getAttributeByValue({ name: name, value: value })) {
    _this.naui.addAttribute({
      nodeId: _this.node.id,
      name: name,
      value: value,
      role: 'card',
      operationMessages: operationMessages
    });

    var _scope = 'Both';
    if (name && !value) {
      _scope = 'Key';
    } else if (!name && value) {
      _scope = 'Value';
    }

    _eventTracking2.default.track({
      category: 'Attributes',
      action: 'Attr-Editor-Single-Add-' + _scope,
      label: 'Attribute-Added'
    });
  }

  if (_this.isEditing) {
    _this.clearInputs();
    _this.hide();
    _this.update();
  } else {
    _this.clearInputs();
    _this.update();
  }
};

var sortKeys = function sortKeys(string, a, b) {
  throw new Error('not implemented');
};

this.autocompleteKey = function (string) {
  _this.autocompleteKeys.sort(function (a, b) {
    sortKeys(string, a, b);
  });
};

this.remove = function () {
  if (_this.isBulkAction) {
    _this.bulkRemove();
  } else {
    _this.singleRemove();
  }
  _this.hide();
};

this.bulkRemove = function () {};

this.singleRemove = function () {
  _this.naui.removeAttribute({
    id: _this.attributeId,
    nodeId: _this.node.id
  });
  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Editor-Single-Remove',
    label: 'Attribute-Removed'
  });
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};

this.initialize();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-attribute-editor')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-attribute-editor.html
// module id = 742
// module chunks = 0